<section *ngIf="state">
    <h6>{{ state }}</h6>

    <div class="mat-subtitle-2 form-hint">{{ message }}</div>
    
    <div *ngIf="showNote" class="mat-subtitle-2 form-hint mb-3">{{ genericNote }}</div>

    <ng-content></ng-content>
</section>
